import { createContext, useContext } from "react";

// Permissões por módulo seguem o shape descrito pelo backend:
// { module: { action: boolean } }
export interface ModulePermissions {
    [action: string]: boolean | undefined;
}

export interface Permissions {
    full_access?: boolean;
    dashboard?: ModulePermissions;
    sales?: ModulePermissions;
    subscriptions?: ModulePermissions;
    products?: ModulePermissions;
    financial?: ModulePermissions;
    integrations?: ModulePermissions;
    collaborators?: ModulePermissions;
    [module: string]: boolean | ModulePermissions | undefined;
}

export interface PermissionsContextData {
    permissions: Permissions | null;
    isCollaborator: boolean;
    hasPermission: (permission: string) => boolean;
    getFirstAvailableRoute: () => string;
    loading: boolean;
    refreshPermissions: () => Promise<void>;
}

// Default seguro: se um consumidor renderizar fora do Provider (ou em um momento
// transitório de HMR/fast refresh), as funções existem e negam acesso por padrão
// em vez de quebrar com "hasPermission is not a function".
export const defaultPermissionsContext: PermissionsContextData = {
    permissions: null,
    isCollaborator: false,
    hasPermission: () => false,
    getFirstAvailableRoute: () => "/no-permission",
    loading: true,
    refreshPermissions: async () => {
        /* no-op */
    },
};

export const PermissionsContext = createContext<PermissionsContextData>(
    defaultPermissionsContext
);

export function usePermissions() {
    return useContext(PermissionsContext);
}
